

<div class="multi-content">
    <nz-divider class="hdivider"></nz-divider>
    <div class="button-table-action">
        <button nz-button nzType="primary" nzDanger [disabled]="dataMultiTable.length == 0 || !hasSelect" (click)="removeItens()">
            <nz-icon nzType="delete"></nz-icon>Remover os selecionados
        </button>
        <div class="flex-spacer"></div>
        <div class="info data">{{ selectedCount }} / {{ dataMultiTable.length }} </div>
    </div>
    <nz-divider class="hdivider"></nz-divider>
    <div class="table-multi">
        <div class="header-line multi-grid" [ngStyle]="{'grid-template-columns': 'repeat(' + colsCount + ', 1fr)'}">
            <div class="checkbox-col">
                <label nz-checkbox [ngModel]="allComplete" (ngModelChange)="onSelectCheckBox($event)" [nzIndeterminate]="someComplete()"></label>
            </div>
            <div class="header" *ngFor="let column of dataMultiTableConfig" [nz-tooltip]="column.columnDesc">
                {{column.columnDesc}}
            </div>
        </div>
        <div class="variation-grid" #grid>
            <div *ngFor="let data of dataMultiTable" class="lines multi-grid" [ngStyle]="{'grid-template-columns': 'repeat(' + colsCount + ', 1fr)'}">
                <div class="checkbox-col">
                    <label nz-checkbox [(ngModel)]="data.selected" (ngModelChange)="updateAllComplete()"></label>
                </div>
                <ng-container *ngFor="let column of dataMultiTableConfig|arrayFilter:'columnName':'selecionar':true">

                    <div class="data-text" *ngIf="column.format=='TEXT'" [nz-tooltip]="data[column.columnName]">
                        {{data[column.columnName]}}
                    </div>

                    <div class="data-int" *ngIf="column.format=='INT'">
                        {{data[column.columnName] | number : '1.0-0'}}
                    </div>

                    <div class="data-float" *ngIf="column.format=='FLOAT'">
                        {{data[column.columnName]| number : '1.2-2':'br'}}
                    </div>

                    <div class="data-date" *ngIf="column.format=='DATE'">
                        {{data[column.columnName]| dateFormatPipe2 : column.dateFromFormat: column.dateFormat}}
                    </div>

                </ng-container>
            </div>
        </div>
    </div>
</div>
